import { Component } from '@angular/core';

@Component({
  selector: '[app-main-content]',
  standalone: false,
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
})
export class MainContentComponent {}
